module.exports = __webpack_public_path__ + "static/media/map1.733c9b53.jpg";